import * as React from 'react';
export default function reactRenderHooksFactory(reactMount, reactUnmount) {
    return function (_a) {
        var lifecycleKey = _a.lifecycleKey, renderable = _a.renderable, data = _a.data;
        // Transform the data from [{a:'b'}, {c:'d'}] to ['b', 'd']
        var inputData = data.map(function (entry) { return entry[Object.keys(entry)[0]]; });
        var isFunction = typeof renderable === 'function';
        var reactContents = isFunction ? renderable.apply(void 0, inputData) : renderable;
        function unmountContent(element) {
            reactUnmount(lifecycleKey, element);
        }
        function renderIntoNode(element) {
            if (typeof reactContents === 'object') {
                return reactMount(lifecycleKey, reactContents, element);
            }
            if (reactContents || typeof reactContents === 'number') {
                return reactMount(lifecycleKey, React.createElement('span', {}, reactContents), element);
            }
            // if there is no content (empty string or false), call React to unmount previous content
            unmountContent(element);
        }
        if (reactContents === null || reactContents === undefined) {
            return null;
        }
        return {
            componentDidMount: renderIntoNode,
            componentDidUpdate: renderIntoNode,
            componentWillUnmount: unmountContent
        };
    };
}
//# sourceMappingURL=react-render-hooks.js.map